module.exports = __webpack_public_path__ + "img/29.0ad6c0f1.png";